import React from "react";
import MuiButton from "@mui/material/Button";

export default function DefaultButton({
  visibility = true,
  disabled = false,
  relative = false,
  minWidth,
  onClick,
  label,
  children,
  sx,
  color,
  ...rest
}) {
  if (!visibility) return null;

  return (
    <MuiButton
      variant="contained"
      aria-label={label}
      size="large"
      onClick={onClick}
      sx={{
        p: 3,
        mb: 1,
        fontSize: "1.5rem",
        fontWeight: 500,
        position: relative ? "relative" : "absolute",
        lineHeight: "1.5rem",
        top: relative ? 0 : 5,
        left: relative ? 0 : 5,
        borderRadius: "15px",
        border: "0px solid white",
        marginBottom: 1,
        minWidth,
        zIndex: 4,
        color: color || "white",
        bgcolor: disabled ? "primary.green" : "primary.red",
        opacity: disabled ? 0.7 : 1,
        ...sx,
      }}
      {...rest}
    >
      {label && !children && label}
      {children}
    </MuiButton>
  );
}
